module.exports = require('./lib/SignalFactory.js');;